/**
 * User object from API / localStorage (roles: string[] from UserResource).
 */
export function isDeliveryPartner(user) {
  if (!user || !Array.isArray(user.roles)) return false;
  return user.roles.some((r) => String(r).trim() === "Delivery Partner");
}

export function parseStoredUser() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
